export enum AdminControlFieldNames {
    ACTION = 'action'
}

export const ACTION_FIELD_NAME: string = AdminControlFieldNames.ACTION
